/* WJW Increment 54: mobile product-only Judge.me rating hydration.
 * Only unrated JS-rendered/third-party mobile cards request a Shopify section.
 * No cart, pricing, quick shop, Boost API or desktop mutations. */
(function () {
  'use strict';
  if (window.WJWInc54Ratings) return;
  var mobile = window.matchMedia('(max-width: 749px)');
  var CARD = '.wjw-boost-discovery__card, .wjw-collection-bestsellers__card, ' +
    '.mobile-collection-product-card, .mobile-featured-product-card, ' +
    '.wjw-search-mobile-card, .wjw-reco-mobile-card, .product-card, ' +
    '#Cart-Drawer .cart-drawer--recommendations .product-cart-item';
  var cache = new Map(), pending = [], active = 0, LIMIT = 3;
  var observer = null, scheduled = false;
  function handle(card) {
    var value = card.dataset.productHandle || card.dataset.wjwProductHandle || card.getAttribute('p-handle') ||
      (card.querySelector('[data-product-handle]') && card.querySelector('[data-product-handle]').dataset.productHandle) || '';
    if (!value) {
      var a = card.matches('a[href*="/products/"]') ? card : card.querySelector('a[href*="/products/"]');
      var match = a && (a.getAttribute('href') || '').match(/\/products\/([a-z0-9_-]+)/i);
      value = match ? match[1] : '';
    }
    return /^[a-z0-9][a-z0-9_-]*$/i.test(value) ? value : '';
  }
  function information(card) {
    return card.querySelector('.wjw-boost-discovery__card-info, .wjw-collection-bestsellers__info, ' +
      '.mobile-collection-product-info, .mobile-featured-product-info, .wjw-search-mobile-card__body, .wjw-reco-mobile-card__body') ||
      (card.matches('.product-cart-item') ? card.lastElementChild : null) || card.querySelector('.product-card-info');
  }
  function ratingData(el) {
    if (!el) return null;
    var count = Number(el.dataset.count), avg = Number(el.dataset.rating), scale = Number(el.dataset.scaleMax || 5);
    if (!(count > 0 && avg > 0 && scale > 0)) {
      var badge = el.querySelector('.jdgm-prev-badge[data-average-rating][data-number-of-reviews]');
      if (badge) { count = Number(badge.dataset.numberOfReviews); avg = Number(badge.dataset.averageRating); scale = 5; }
    }
    if (!(count > 0 && avg > 0 && scale > 0)) return null;
    var score = Math.min(5, Math.max(0, (avg / scale) * 5));
    if (!Number.isFinite(score)) return null;
    return {score: score, count: Math.floor(count)};
  }
  function createRating(rating) {
    var row = document.createElement('span'); row.className = 'wjw-inc54-rating';
    row.setAttribute('data-wjw-inc54-rating-present', ''); row.setAttribute('role', 'img');
    row.setAttribute('aria-label', 'Rated ' + rating.score.toFixed(1) + ' out of 5, ' + rating.count + ' product reviews');
    var stars = document.createElement('span'); stars.className = 'wjw-inc54-rating__stars';
    stars.textContent = '★★★★★'; stars.setAttribute('aria-hidden', 'true');
    stars.style.setProperty('--wjw-inc54-fill', Math.round(rating.score * 20) + '%');
    var count = document.createElement('span'); count.className = 'wjw-inc54-rating__count';
    count.textContent = '(' + rating.count + ')'; count.setAttribute('aria-hidden', 'true');
    row.append(stars, count); return row;
  }
  function insert(card, rating) {
    if (!mobile.matches || !card.isConnected || !rating || card.querySelector('[data-wjw-inc54-rating-present]')) return;
    var info = information(card); if (!info) return;
    var title = info.querySelector('.wjw-boost-discovery__product-title,.wjw-collection-bestsellers__product-title,' +
      '.mobile-collection-product-title,.mobile-featured-product-title,.wjw-search-mobile-card__title,' +
      '.wjw-reco-mobile-card__title,.cart-product-link,.product-card-title');
    if (!title) return;
    title.after(createRating(rating));
  }
  function fetchOne(handle) {
    var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
    var url = root + 'products/' + encodeURIComponent(handle) + '?section_id=wjw-inc54-product-rating-source';
    return fetch(url, {credentials: 'same-origin'}).then(function (response) {
      if (!response.ok) return null;
      return response.text();
    }).then(function (html) {
      if (!html) return null;
      var dom = new DOMParser().parseFromString(html, 'text/html');
      var el = dom.querySelector('[data-wjw-inc54-source]');
      if (!el || el.dataset.handle !== handle) return null;
      return ratingData(el);
    }).catch(function () { return null; });
  }
  function next() {
    while (active < LIMIT && pending.length) {
      let job = pending.shift(); active++;
      fetchOne(job.handle).then(function (rating) { job.resolve(rating); })
        .finally(function () { active--; next(); });
    }
  }
  function get(handle) {
    if (!cache.has(handle)) cache.set(handle, new Promise(function (resolve) {
      pending.push({handle: handle, resolve: resolve}); next();
    }));
    return cache.get(handle);
  }
  function hydrate(card) {
    if (!mobile.matches || card.dataset.wjwInc54Queued === '1') return;
    card.dataset.wjwInc54Queued = '1';
    // The Liquid snippet already renders authoritative product ratings without fetch.
    if (card.querySelector('[data-wjw-inc54-rating-present], .jdgm-product-card-badge .jdgm-prev-badge[data-number-of-reviews]:not([data-number-of-reviews="0"])')) return;
    var h = handle(card); if (!h) return;
    get(h).then(function (rating) { insert(card, rating); });
  }
  function scan(root) {
    if (!mobile.matches) return;
    var base = root && root.querySelectorAll ? root : document;
    var cards = base.matches && base.matches(CARD) ? [base].concat(Array.from(base.querySelectorAll(CARD))) : base.querySelectorAll(CARD);
    Array.from(cards).forEach(function (card) {
      if (card.dataset.wjwInc54Queued === '1') return;
      if (observer) observer.observe(card); else hydrate(card);
    });
  }
  function schedule(root) {
    if (!mobile.matches) return;
    if (root) { scan(root); return; }
    if (scheduled) return;
    scheduled = true; requestAnimationFrame(function () { scheduled = false; scan(document); });
  }
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { observer.unobserve(entry.target); hydrate(entry.target); }
      });
    }, {rootMargin:'200px 0px'});
  }
  document.addEventListener('wjw:cards-inserted', function (e) { schedule(e.detail && e.detail.root); });
  document.addEventListener('shopify:section:load', function (e) { schedule(e.target); });
  document.addEventListener('cart:updated', function () { schedule(); });
  if ('MutationObserver' in window) {
    var mutation = new MutationObserver(function (records) {
      if (!mobile.matches) return;
      for (var i=0; i<records.length; i++) if (records[i].addedNodes.length) { schedule(); break; }
    });
    mutation.observe(document.documentElement, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { schedule(); });
  else schedule();
  window.WJWInc54Ratings = {refresh:schedule};
})();
